module.exports = __webpack_public_path__ + "media/application/images/2018/bookmark-icons-5f6922fb92117c08d39a9850ee663a0a.png";